import { render } from "./color-input.vue?vue&type=template&id=401cff4d"
import script from "./color-input.vue?vue&type=script&lang=js"
export * from "./color-input.vue?vue&type=script&lang=js"

import "./color-input.vue?vue&type=style&index=0&id=401cff4d&lang=scss"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__